module.exports = __webpack_public_path__ + "static/img/pic_pdf_big.58d27c08.png";